import React from 'react';
import PropTypes from 'prop-types';

function Toggle({ onChange }) {
  return (
    <label htmlFor="default-toggle" className="inline-flex relative items-center cursor-pointer mx-2">
      <input type="checkbox" value="" id="default-toggle" className="sr-only peer" onChange={(e) => onChange(e.target.checked)} />
      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-wellington-green-100 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-wellington-green-500" />
    </label>
  );
}

Toggle.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default Toggle;
